






























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import { GetPreviousKnowledgeList } from "@/api/pdOutPatient/pdEducation/pdPreviousEducation";
import PdPreviousEducationPlay from "./pdPreviousEducationPlay.vue";
@Component({
  components: {
    PdPreviousEducationPlay
  }
})
export default class PdPreviousEducation extends AbpBase {
  @Prop() patient: any;
  showAddPreviousEducation: boolean = false;
  loading: boolean = false;
  PreviousEducationList: any[] = [];
  pdPreviousEducation: any = {};
  PreviousKnowledge = [
    {
      title: "宣教时间",
      key: "xjrq",
      render: (h: any, p: any) => {
        return h("span", {}, this.formatDateTime(p.row.xjrq));
      }
    },
    {
      title: "推荐材料",
      key: "name"
    },
    {
      title: "结束时间",
      key: "endTime",
      render: (h: any, p: any) => {
        return h("span", {}, this.formatDateTime(p.row.endTime));
      }
    },
    {
      title: "持续时间",
      key: "holdTime",
      render: (h: any, p: any) => {
        return h("span", {}, p.row.holdTime + "分钟");
      }
    },
    {
      title: "宣教者",
      key: "xjr"
    },
    {
      title: "操作",
      key: "",
      render: (h: any, p: any) => {
        return h("div", [
          h("Button", {
            props: { type: "success", icon: "ios-videocam", size: "small" },
            style: { marginRight: "5px" },
            on: {
              click: () => {
                this.onPreviousEducationPlay(p.row);
              }
            }
          })
        ]);
      }
    }
  ];

  @Watch("patient", { immediate: false, deep: true })
  async getData() {
    this.loading = true;
    this.pdPreviousEducation = {};
    var res = await GetPreviousKnowledgeList(this.patient.pD_Patient_ID);
    this.PreviousEducationList = res.objects;
    this.loading = false;
  }

  //播放
  onPreviousEducationPlay(data: any) {
    this.pdPreviousEducation = data;
    this.showAddPreviousEducation = true;
  }

  //新增宣教情况
  onAddPdPreviousEducationOK() {
    this.loading = true;
    this.$refs.PdPreviousEducationPlay.submit().then(res => {
      if (res) {
        this.showAddPreviousEducation = false;
        this.getData();
      }
    });
    this.loading = false;
  }
  constructor() {
    super();
    this.getData();
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdOutPatient/pdEducation/pdPreviousEducation/index.vue